








































































































export default {
    name: 'LinkWamlyProjectToJobDialog',

    props: {
        job: {
            type: Object,
            required: true,
        },
    },

    setup(props, { emit }) {
        const { $store, $toast } = useNuxtApp();

        const error = ref<string | null>(null);
        const fetchingProjects = ref<boolean>(false);
        const linkingProject = ref<boolean>(false);
        const selectedWamlyProjectId = ref<string | null>(null);
        const showError = ref<boolean>(false);

        const projects = computed(() => $store.getters['wamly/getProjects']);
        const hasProjects = computed(() => Boolean(Object.keys(projects.value).length));

        const closeModal = () => {
            emit('close-modal');
        };

        const fetchProjects = () => {
            fetchingProjects.value = true;

            $store
                .dispatch('wamly/getProjects')
                .finally(() => {
                    fetchingProjects.value = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        };

        const linkProjectToJob = () => {
            if (!selectedWamlyProjectId.value) {
                showError.value = true;
                return;
            }

            const project = findProjectById(selectedWamlyProjectId.value);

            if (!project) {
                $toast.danger('Oops! Something wrong. Please try again.');
                return;
            }

            linkingProject.value = true;

            $store
                .dispatch('wamly/linkProjectToJob', {
                    job_uuid: props.job.uuid,
                    project_id: project.id,
                    project_name: project.name,
                    project_link: project.generic_link,
                })
                .then(() => {
                    $toast.success('Wamly project linked successfully!');
                    closeModal();
                })
                .finally(() => {
                    linkingProject.value = false;
                })
                .catch((error) => {
                    if (error.response?.status === 422) {
                        error.value = error.response.data.message;
                        return;
                    }

                    if (error.response?.status === 403) {
                        $toast.danger('You are not permitted to perform this action.');
                        return;
                    }

                    console.log(error);
                    $toast.danger('Oops! Something wrong. Please try again.');
                });
        };

        const setDefaultSelectedProjectId = () => {
            selectedWamlyProjectId.value = props.job.wamly_project?.project_id;
        };

        const findProjectById = (id: string) => {
            return projects.value.find((project: object) => project.id === id);
        };

        setDefaultSelectedProjectId();
        fetchProjects();

        return {
            closeModal,
            error,
            fetchingProjects,
            hasProjects,
            linkingProject,
            linkProjectToJob,
            projects,
            selectedWamlyProjectId,
            showError,
        };
    },
};
